import ActionTypes from "../../../constants/ActionTypes";
import { IMunicipality, INeighborhood, IStreet } from "../../../entities/pak/types";
import { IFetchCitiesAction, ISetCitiesAction, IFetchNeighborhoodsAction, ISetNeighborhoodsAction, IFetchStreetsAction, ISetStreetsAction } from "./types";

export const fetchCitiesAction = (): IFetchCitiesAction => {
  return {
    type: ActionTypes.PAK.FETCH_CITIES
  };
};

export const setCitiesAction = (cities: IMunicipality[]): ISetCitiesAction => {
  return {
    type: ActionTypes.PAK.SET_CITIES,
    payload: cities,
  };
};

export const fetchNeighborhoodsAction = (municipality: string, city: string | null): IFetchNeighborhoodsAction => {
  return {
    type: ActionTypes.PAK.FETCH_NEIGHBORHOODS,
    payload: {
      municipality,
      city
    }
  };
};

export const setNeighborhoodAction = (neighborhoods: INeighborhood[]): ISetNeighborhoodsAction => {
  return {
    type: ActionTypes.PAK.SET_NEIGHBORHOODS,
    payload: neighborhoods,
  };
};

export const fetchStreetsAction = (municipality: string, neighborhood: string): IFetchStreetsAction => {
  return {
    type: ActionTypes.PAK.FETCH_STREETS,
    payload: {
      municipality,
      neighborhood
    }
  };
};

export const setStreetsAction = (streets: IStreet[]): ISetStreetsAction => {
  return {
    type: ActionTypes.PAK.SET_STREETS,
    payload: streets,
  };
};
